module.exports = __webpack_public_path__ + "static/img/2-05.db6e826.png";


//////////////////
// WEBPACK FOOTER
// ./static/feige/3/2-05.png
// module id = 222
// module chunks = 0